import { Injectable } from '@angular/core';
import { IUser } from '../../models/user';
import { IMessage } from '../../models/message';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RoleName } from '../../models/user/role-info/RoleName';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';



declare var jQuery: any;

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  currentUser: IUser;
  // public showLoader = new BehaviorSubject<boolean>(false);
  public showLoader: BehaviorSubject<boolean> = new BehaviorSubject(false);
  incomingTicketId: string;
  isBlocked: boolean;
  messages: Array<IMessage>;
  isOffline: boolean;
  isNotMobileDevice: boolean;
  currentPageTitle: string;
  RoleName = RoleName;
  menuOpen = true;
  breadCrumbs = [];
  businessUnit: string;
  doctorId: string;

  constructor(private http: HttpClient, private router: Router, private snackBar: MatSnackBar) {
    this.isNotMobileDevice = window.screen.width >= 767;
    this.menuOpen = this.isNotMobileDevice;
    const currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser != null) {
      this.currentUser = currentUser;
    }
    const breadCrumbs = JSON.parse(localStorage.getItem('breadCrumbs'));
    if (breadCrumbs != null) {
      this.breadCrumbs = breadCrumbs;
    } else {
      this.breadCrumbs = [];
    }
    const businessUnit = localStorage.getItem('businessUnit');
    if (businessUnit) {
      this.businessUnit = businessUnit;
    }
  }

  clearBreadCrumbs() {
    this.breadCrumbs = [];
    localStorage.removeItem('breadCrumbs');
  }

  addBreadCrumb(displayText: string, url: string) {
    const breadCrumb: any = {};
    breadCrumb.displayText = displayText;
    breadCrumb.url = url;
    let isFound = false;
    for (let i = 0; i < this.breadCrumbs.length; i++) {
      if (this.breadCrumbs[i].displayText === displayText || this.breadCrumbs[i].url === url) {
        isFound = true;
        break;
      }
    }
    if (!isFound) {
      this.breadCrumbs.push(breadCrumb);
      localStorage.setItem('breadCrumbs', JSON.stringify(this.breadCrumbs));
    }
  }

  goToBreadcrumb(url: string) {
    let index = -1;
    const indicesToBeDeleted: Array<number> = [];
    for (let i = 0; i < this.breadCrumbs.length; i++) {
      if (this.breadCrumbs[i].url === url) {
        index = i;
        break;
      }
    }
    if (index > -1) {
      for (let i = 0; i < this.breadCrumbs.length; i++) {
        if (i > index) {
          indicesToBeDeleted.push(i);
        }
      }
    }
    for (let i = 0; i < indicesToBeDeleted.length; i++) {
      this.breadCrumbs.splice(indicesToBeDeleted[i], 1);
    }
    localStorage.setItem('breadCrumbs', JSON.stringify(this.breadCrumbs));
    this.router.navigate([url]);
  }

  saveUserLocally(user: any): boolean {
    this.currentUser = user;
    if (user.rolesInfo == null) {
      return false;
    }
    localStorage.setItem('currentUser', JSON.stringify(user));
    return true;
  }

  public logout(): Observable<any> {
    const url = `${environment.apiOrigin}/api/security/sign-out`;
    return this.http.post(url, {});
  }


  public updateActiveRole(role: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/security/roles/set`;

    return this.http.post(url, {}, {
      params: new HttpParams().set('roleName', role)
    });
  }


  showModalDialog(id: string): void {
    jQuery('#' + id).modal('show');
  }

  hideModalDialog(id: string): void {
    jQuery('#' + id).modal('hide');
  }

  updateUser(customerId: string, field: string, value: string): Observable<any> {
    const url = `${environment.apiOrigin}/UserService/api/user/field/update`;
    return this.http.post(url, {}, {
      params: new HttpParams().set('userId', customerId).set('field', field).set('value', value)
    });
  }

  public getPinCodeData(pinCode: string): Observable<any> {
    const url = `${environment.apiOrigin}/ApplicationService/api/common/pincodes/${pinCode}`;

    return this.http.get(url);
  }

  public createUser(user: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/users/create`;

    return this.http.post(url, user);
  }

  public setUser(user: any) {
    const returnUser: any = {};

    if (user != null) {
      if (user.id != null) {
        returnUser._id = user._id;
        returnUser.id = user.id;
        returnUser.name = user.name;
        returnUser.mobileNumber = user.mobileNumber;
        returnUser.emailAddress = user.emailAddress;
        returnUser.gender = user.gender;
        returnUser.dateOfBirth = this.formatDate(new Date(user.dateOfBirth));
        returnUser.rolesInfo = user.rolesInfo ? user.rolesInfo : [];
        returnUser.organization = user.organization;
        returnUser.location = user.location;
        returnUser.department = user.department;
        returnUser.designation = user.designation;
        returnUser.functionalRole = user.functionalRole;
        returnUser.isActive = user.isActive;
        returnUser.escalationTo = user.escalationTo;

        if (user.metadata) {
          returnUser.metadata = user.metadata;
        }

      }
    } else {
      returnUser.isNew = true;
    }
    return returnUser;
  }

  formatDate(date: any) {
    if (!date) {
      return '';
    }
    date = new Date(date);
    if (date.getFullYear() < 2000) {
      return '';
    }
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }

  getFormatedtDate(date: any) {
    if (!date) {
      return '';
    }
    const splittedDate = date.split('-');
    const newDate = splittedDate[1] + '-' + splittedDate[0] + '-' + splittedDate[2];
    let d = new Date(newDate),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }
    return [month, day, year].join('/');
  }


  isAdministratorLoggedIn(): boolean {
    if (this.currentUser) {
      if (this.currentUser.rolesInfo) {
        for (let i = 0; i < this.currentUser.rolesInfo.length; i++) {
          if (this.currentUser.rolesInfo[i].name === this.RoleName.ADMINISTRATOR) {
            return true;
          }
        }
      }
    }
    return false;
  }

  public getUniqueValues(collection: string, field: string): Observable<any> {
    const url = `${environment.apiOrigin}/ApplicationService/unique-values`;
    let params = new HttpParams();
    params = params.append('collection', collection);
    params = params.append('field', field);

    return this.http.get(url, { params: params });
  }

  public uploadMediaDocuments(files: any, tag: string): Observable<any> {
    const url = `${environment.apiOrigin}/Application/v1/UploadDocuments`;
    const formData: FormData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }
    formData.append('tags', tag);

    return this.http.post(url, formData);
  }

  getDateFromObjectId(objectId: string) {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
  }

  public getCountries(): Observable<any> {
    const url = `${environment.apiOrigin}/Application/v1/GetCountries`;

    return this.http.get(url);
  }

  checkAdminSetup(): Observable<any> {
    const url = `${environment.apiOrigin}/api/application/check-admin-setup`;
    return this.http.get(url);
  }

  isCurrentUserHasRole(roleToBeChecked: string): boolean {
    for (const role of this.currentUser.rolesInfo) {
      if (role.name === roleToBeChecked) {
        return true;
      }
    }
    return false;
  }

  ckeckWithEmail() {
    let isPharmacist = this.currentUser.activeRoleInfo.name == this.RoleName.PHARMACIST ? true : false;
    return isPharmacist;
    // let arr=['vishnu.kant@mankindpharma.com','sharmaashutosh9319@gmail.com','mdkhan.bismillah@gmail.com','ananthenterprises2022@gmail.com','aarkmankind@gmail.com','saishreetraders4u@gmail.com']
    // if(arr.includes(this.currentUser.emailAddress)){
    //   return true
    // }
    // return false;
  }

  getBusinessUnit(): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/fetch-business-unit`;
    return this.http.get(url);
  }

  getFormattedDate(date: any): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }
  getFormattedDate1(date: any): string {

    const newDateString = date.split('-');
    const newDate = newDateString[1] + '-' + newDateString[0] + '-' + newDateString[2];
    const d = new Date(newDate);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }
  getCityStateCountry(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/pin-code-details/${value}`;
    return this.http.get(url);
  }

  getApplications(): Observable<any> {
    const url = `${environment.apiOrigin}/api/application/authorized-applications`;
    return this.http.get(url);
  }

  isSalesUser(): boolean {
    for (const role of this.currentUser.rolesInfo) {
      if (role.name === RoleName.SALES) {
        return true;
      }
    }
    return false;
  }
  isCustomerServiceUser(): boolean {
    for (const role of this.currentUser.rolesInfo) {
      if (role.name === RoleName.SERVICE || role.name === RoleName.SERVICE1 || role.name === RoleName.SERVICE2) {
        return true;
      }
    }
    return false;
  }
  isEnterValidNameOrEmailOrMobileNo(value: any) {


    if (value.includes('@')) {
      let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
      if (!regex.test(value)) {
        this.snackBar.open('Please enter valid email!', '', { duration: 3000 });
        return false
      }
    }
    else {


      let countNum = value.replace(/[^0-9]/g, "").length;

      if (!isNaN(value)) {

        let regex = /^[6-9]{1}[0-9]{9}$/;
        if (!regex.test(value)) {
          this.snackBar.open('Please enter valid modile number!', '', { duration: 3000 });
          return false
        }

      }
      else if (countNum >= 7) {

        let regex = /^[6-9]{1}[0-9]{9}$/;
        if (!regex.test(value)) {
          this.snackBar.open('Please enter valid modile number!', '', { duration: 3000 });
          return false
        }
      }
      else {

        let regex = /^[a-zA-Z '.-]+$/;
        if (!regex.test(value)) {
          this.snackBar.open('Please enter valid name!', '', { duration: 3000 });
          return false
        }

      }


    }
    return true;

  }
}

